import {
  getScanners,
  getStatus,
} from 'services/testConnect';
import events from 'lib/events';
import {testConnectSidebarEnabled} from 'features';
import {UseHTTPScannerInterface} from "lib/globals";

class TestConnectStatusService {
  latestTcVersion = '1.6.0.0';
  status = {
    scanErrors: false,
    needsUpdate: false,
  };
  started = false;

  init() {
    if (this.started) return;

    if (!testConnectSidebarEnabled) {
      return;
    }

    this.started=true;

    setTimeout(() => {
      getStatus().then(status => {
        if (status.version) {
          this.timer = setInterval(() => {
            getStatus().then(status => {

              for (let i = 0; i < status.scanners.length; i++) {
                if(status.scanners[i].includes('-update') && status.version && status.version.includes('1.6')) {
                  status.scanners.splice(i, 1);
                  this.status.needsUpdate = true;
                  break;
                }
              }

              this.status.scanners = status.scanners;
              this.status.versionOutOfDate = status.version < this.latestTcVersion;
              this.status.version = status.version;
              this.status.noScannersFound = status.scanners.length === 1;
              this.status.hasSocket = status.connected;
            }).catch(err => {
              console.log('Error getting status', err);
            }).finally(() => {
              this.publishErrorStatus();
              this.publishUpdateStatus();
            });
          }, 5000);
        } else {
          // Old version. Get scanner status from getScanners and set it.
          getScanners().then(s => {

            for (let i = 0; i < s.scanners.length; i++) {
              if(s.scanners[i].includes('-update') && s.version &&s.version.includes('1.6')) {
                s.scanners.splice(i, 1);
                this.status.needsUpdate = true;
                break;
              }
            }

            this.status.versionOutOfDate = s.version < this.latestTcVersion;
            this.status.version = s.version;
            this.status.noScannersFound = s.scanners.length === 1;
            this.status.scanners = s.scanners;
            this.status.hasSocket = s.connected;
          }).catch(err => {
            console.log('Error getting scanners', err);
          }).finally(() => {
            this.publishErrorStatus();
            this.publishUpdateStatus();
          });
        }
      });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  getStatus = () => {
    return this.status;
  };

  setScanErrors = (err) => {
    this.status.scanErrors = err;
    this.publishErrorStatus();
  };

  publishErrorStatus = () => {
    let hasErrors = this.status.versionOutOfDate ||
      this.status.noScannersFound ||
      !this.status.hasSocket || this.status.scanErrors;

    events.publish('testconnect.hasErrors', hasErrors);
  };

  publishUpdateStatus = () => {    
    events.publish('testconnect.needsUpdate', this.status.needsUpdate);
  }
}
let tcStatusService = new TestConnectStatusService();
UseHTTPScannerInterface.then((val) => {
  if(val===false){
    tcStatusService.init();
  }
});

export default tcStatusService;